import { HeaderService } from '../../../services/header.service';
import { NgwWowService } from 'ngx-wow';
import { CMSEnum } from './../../../models/enums/CMS/CMSEnum';
import { CmsService } from './../../../services/cms.service';

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {

  HomeBanner;

  constructor(private wowService: NgwWowService, private cmsService:CmsService) {
    this.wowService.init();
  }

  ngOnInit(): void {
    this.cmsService.contentModel.subscribe(res =>{
      if(res!=null&&res.contents!=null){
        this.HomeBanner=res.contents.filter(a => a.sectionID==CMSEnum.HomeContent)[0];
      }
    })
  }

}
